// pages/Contact.js
import React from 'react';

function Contact() {
  return (
    <div>
      <h1>Contato</h1>
      <p>Entre em contato conosco para mais informações.</p>
    </div>
  );
}

export default Contact;
